var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0714 6.30907V4.55333C10.0714 2.3176 8.24571 0.5 6 0.5C3.75429 0.5 1.92857 2.3176 1.92857 4.55333V6.30907C0.645 6.50747 0 7.34373 0 8.82V13.94C0 15.6467 0.857143 16.5 2.57143 16.5H9.42857C11.1429 16.5 12 15.6467 12 13.94V8.82C12 7.34373 11.355 6.50747 10.0714 6.30907ZM6.64286 11.3693V13.0867C6.64286 13.4408 6.35571 13.7267 6 13.7267C5.64429 13.7267 5.35714 13.4408 5.35714 13.0867V11.348C5.11071 11.1517 4.94143 10.8637 4.94143 10.5267C4.94143 9.93787 5.41714 9.46 6.00857 9.46H6.01714C6.60857 9.46 7.08857 9.93787 7.08857 10.5267C7.08857 10.8787 6.90643 11.1752 6.64286 11.3693ZM8.78571 6.26H3.21429V4.55333C3.21429 3.02587 4.46571 1.78 6 1.78C7.53429 1.78 8.78571 3.02587 8.78571 4.55333V6.26Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.7fcbe533be264b87999f5559dc767144.svg";
export { ForwardRef as ReactComponent };